import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NumericInputComponent } from '@shared/components/numeric-input/numeric-input.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { FormsModule } from '@angular/forms';
import { SvgModule } from '@shared/components/svg/svg.module';

@NgModule({
  declarations: [NumericInputComponent],
  imports: [CommonModule, MatFormFieldModule, MatInputModule, FormsModule, SvgModule],
  exports: [NumericInputComponent]
})
export class NumericInputModule {}
